import { Button } from '@mui/material';
import { useState } from 'react';
import { Menu, MenuItem } from '@/components/tour/notes/components/ui/StyledMenu';
import { useNotesContext } from '@/components/tour/notes/hooks/useNotesContext';
import { useAddNote } from '@/components/tour/notes/hooks/useAddNote';
import { AddNoteMode } from '@/components/tour/notes/enums';
import { Icon } from '@/units/index';

export function AddNoteButton() {
  const { setAddingWorkflow, tour, setIsBoardOpen } = useNotesContext();
  const { handleAddNote } = useAddNote();
  const [anchor, setAnchor] = useState(null);

  return (
    <>
      <Button
        onClick={(e) => {
          if (!tour.tagNotesEnabled) {
            setIsBoardOpen(false);
            handleAddNote();
            return;
          }

          setAnchor(e.currentTarget);
        }}
        variant="contained"
        startIcon={<Icon.Add />}
        sx={{
          backgroundColor: '#2055FF',
          color: 'var(--White, #FFF)',
          borderRadius: '8px',
          px: '18px',
          height: '44px',
          width: 'fit-content',
          fontFamily: 'Inter',
          fontSize: '14px',
          fontStyle: 'normal',
          fontWeight: 600,
          lineHeight: '24px',
          'box-shadow': '0px 1px 2px 0px #1018280D',
          '& .MuiButton-startIcon': {
            marginRight: '8px',
          },
          '@container board-content (max-width: 1440px)': {
            px: '0',
            minWidth: '44px',
            width: '44px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            '& .MuiButton-startIcon': {
              marginRight: '0',
              marginLeft: '0',
              position: 'absolute',
            },
            '& .MuiButton-endIcon': {
              marginLeft: '0',
            },
            '& .button-text': {
              display: 'none',
            },
          },
        }}
      >
        <span className="button-text">Add note</span>
      </Button>

      <Menu
        open={!!anchor}
        anchorEl={anchor}
        onClose={() => setAnchor(null)}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        sx={{
          '& .MuiPaper-root': {
            marginTop: '8px',
          },
        }}
      >
        <MenuItem
          onClick={() => {
            setIsBoardOpen(false);
            handleAddNote();
            setAnchor(null);
          }}
        >
          Temporary Note
        </MenuItem>
        <MenuItem
          onClick={() => {
            setIsBoardOpen(false);
            setAnchor(null);
            setAddingWorkflow({ active: true, mode: AddNoteMode.Tag });
          }}
        >
          Choose Tag
        </MenuItem>
      </Menu>
    </>
  );
}
